import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import axios from "axios";
import { BASE_API_URL } from "../constant";
import './SettingsPage.css';

function SettingsPage() {
    // Notification.requestPermission()
    const [language, setLanguage] = useState('English');
    // State for notification setting (default: enabled)
    const [notificationsEnabled, setNotificationsEnabled] = useState(true);

    const handleLanguageChange = (e) => {
        // Update the language setting when the user selects a different language
        setLanguage(e.target.value);
    };

    const handleNotificationToggle = () => {
        setNotificationsEnabled(!notificationsEnabled);
    };

    const token = localStorage.getItem("token");

    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    const handleSettings = async (e) => {
        e.preventDefault();
        await axios.post(BASE_API_URL + "api/user/settings", {
            language,
            notificationsEnabled
        }, config).then(() => {
            alert("Your settings has been updated");
        }).catch((err) => {
            console.log(err);
        });
    }

    // const handleNotification = (e) => {

    //     if (!("Notification" in window)) {
    //         // Check if the browser supports notifications
    //         alert("This browser does not support desktop notification");
    //     } else if (Notification.permission === "granted") {
    //         // Check whether notification permissions have already been granted;
    //         // if so, create a notification
    //         const notification = new Notification("Hi there!");
    //         // …
    //     } else if (Notification.permission !== "denied") {
    //         // We need to ask the user for permission
    //         Notification.requestPermission().then((permission) => {
    //             // If the user accepts, let's create a notification
    //             if (permission === "granted") {
    //                 const notification = new Notification("Hi there!");
    //                 // …
    //             }
    //         });
    //     }
    // }

    return (
        <Container className="custom-container">
            <h2>Settings and Notifications</h2>
            <Form onSubmit={handleSettings}>
                <Form.Group className="m-3">
                    <Form.Label>Language</Form.Label>
                    <Form.Control as="select" value={language} onChange={handleLanguageChange}>
                        <option>English</option>
                        <option>Hindi</option>
                        <option>Telugu</option>
                        <option>Tamil</option>
                        <option>Marathi</option>
                        <option>Kannada</option>
                        <option>Malyalam</option>
                        <option>Bengali</option>
                    </Form.Control>
                </Form.Group>
                <Form.Group className="m-3">
                    <Form.Label>Enable Notifications</Form.Label>
                    <Form.Check
                        type="switch"
                        id="notificationSwitch"
                        checked={notificationsEnabled}
                        onChange={handleNotificationToggle}
                    // label="Enable Notifications"
                    // className="d-flex justify-content-center align-items-center"
                    />
                </Form.Group>
                <Button variant="primary" type="submit" className="text-center">Save Settings</Button>
            </Form>
            {/* <Button variant="success" onClick={handleNotification} >Push Notification</Button> */}
        </Container>
    );
}

export default SettingsPage;
